/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { ListView } from 'antd-mobile'
import { useOnMount } from '@utils/reactExt'
import * as _ from 'lodash'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON, MATCHUP_DETAIL_CONTENT_TAB_KEY } from '@constants/index'
import { SportTalkItem } from 'components/SportTalkItem'
import { Schema$CheerForTeam } from '@interface/cheer-for-team'


type PostingCheerForTeamProps = {
  baseMonth?: string
}

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
})

const ListViewStyle = css`
  height: calc(100% - 40px);
  .preview-box-wrap {
    width: 100%;
  }
`

export const PostingCheerForTeam: React.FC<PostingCheerForTeamProps> = observer((
  props: PostingCheerForTeamProps
) => {
  const { baseMonth } = props
  const { cheerForTeamStore, matchupStore } = useRootStore()
  const { myCheerForTeams, hasMoreMyCheerForTeams } = cheerForTeamStore

  useOnMount(() => {
    fetch(true)
  })

  const fetch = (reset = false) => {
    cheerForTeamStore.fetchMyCheerForTeams(baseMonth, reset).catch(console.error)
  }

  const renderHeader = (): React.ReactElement => {
    return <Fragment/>
  }

  const renderRow = (item: Schema$CheerForTeam) => {
    return (
      <SportTalkItem
        showSimpleCheerForTeamInfo
        sportTalk={item}
        fetchCheerForTeams={() => {
          fetch(true)

          if (matchupStore.matchupDetailContentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK
            && item.matchId === matchupStore.detailMatchId) {
            cheerForTeamStore.fetchSportTalkListInMatchDetail(item.matchId, true).catch(console.error)
          }
        }}
      />
    )
  }

  const renderFooter = (): React.ReactElement => {
    let footer
    if (_.size(myCheerForTeams) > 0) {
      footer = <Fragment/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.SPORT_TALK_LIST}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = () => {
    if (hasMoreMyCheerForTeams) {
      fetch()
    }
  }

  return (
    <ListView
      css={ListViewStyle}
      dataSource={dataSource.cloneWithRows(myCheerForTeams ?? [])}
      renderHeader={renderHeader}
      renderRow={renderRow}
      scrollRenderAheadDistance={500}
      renderFooter={renderFooter}
      onEndReached={endReachedHandler}
      onEndReachedThreshold={10}
      initialListSize={9}
      pageSize={9}
    />
  )
})
